export default __webpack_public_path__ + "static/media/Binary.abf06111.jpg";